<template>
  <div class="protocol">
    <div class="bt">
      Welcome to use {{ appName }}&#39;s &quot;SVIP&quot; automatic renewal
      entrusted deduction service (hereinafter referred to as the
      &quot;automatic renewal service&quot; or &quot;the service&quot;). Before
      you activate this service, please be sure to read carefully and fully
      understand the contents of each clause, especially the exemption or
      Limitation of liability provisions, applicable law and dispute resolution
      provisions. If you have any questions about the agreement, you can consult
      customer service.
    </div>

    <div class="bt">
      If you are under 18 years old, please read this agreement with a legal
      guardian.
    </div>

    <div class="bt">
      If you do not agree with any content of this agreement or cannot
      accurately understand the meaning and interpretation of the terms, please
      do not proceed further. If you purchase or use this service, you have
      reached an agreement with {{ appName }} and voluntarily accept all the
      contents of this agreement.
    </div>

    <div class="bt">
      {{ appName }} &quot;SVIP&quot; Automatic Renewal Service Agreement
    </div>

    <div class="bt">
      Article 1 Acceptance and Amendment of Service Agreement
    </div>

    1.1 The content of this agreement includes the main text of the agreement,
    &quot;{{ appName }} User Agreement&quot;, &quot;{{ appName }} Privacy
    Protection Guidelines&quot;, &quot;{{ appName }} &quot;SVIP&quot; Service
    Agreement&quot; and various rules that {{ appName }} has published or may
    publish/update in the future. All rules are an integral part of this
    agreement and have the same legal effect as the main text of the agreement.
    If there is a conflict between the main text of this agreement and the
    aforementioned rules, the main text of this agreement shall prevail. Unless
    otherwise expressly stated, your use of automatic renewal services is bound
    by this Agreement. 1.2 If business development requires revision of this
    Agreement and related service terms and rules, {{ appName }} will announce
    it on the platform, official website and other channels. You can check the
    latest version of the terms of the agreement here. After
    {{ appName }} modifies the above terms, if you do not accept the modified
    terms, you may choose to terminate the use of the automatic renewal service.
    Your continued use of this service will be deemed to have accepted the
    modified agreement.

    <div class="bt">Article 2 Service Description</div>

    2.1 &quot;SVIP&quot; automatic renewal service refers to a service provided
    on the premise that you have activated &quot;SVIP&quot; and based on your
    need for continuous use of the rights you have obtained to avoid failure to
    renew in time due to negligence or other reasons. The automatic renewal
    service is a continuous monthly subscription package, and the corresponding
    billing cycle fee is a monthly fee. If there is a new continuous
    subscription package, {{ appName }} will announce it on the relevant page.
    2.2 Automatic renewal: You entrust {{ appName }} to use your own recharge
    account, third-party payment account bound to the membership account, bank
    card, payment account bound to the Apple Store account and other accounts
    (hereinafter referred to as the &quot;Account&quot;) through payment
    channels. The fee for the next billing cycle of the corresponding paid
    service will be charged, the amount will be recorded in the payment record,
    and the validity period of the paid service will be extended accordingly.
    2.3 If you activate this service, you are deemed to have authorized
    {{ appName }} to issue a deduction instruction in accordance with the
    deduction rules of the payment channel when the &quot;SVIP&quot; service
    type you have opened is about to expire, and agree that the payment channel
    can do so without verifying your If you provide the account password,
    payment password, SMS verification code and other information, the fee for
    the next billing cycle will be deducted from the above account. If different
    types of automatic renewal services are activated at different points in
    time, the last service type activated will prevail. The automatic deduction
    rules of Apple channels shall be subject to Apple&#39;s regulations and the
    actual deduction time. 2.4 The premise for the realization of this service
    is that you have bound your SVIP account to the above account and can
    successfully deduct the full amount from the above account. Failure to renew
    due to insufficient deductible balance in the above account shall be borne
    by you (including but not limited to termination of corresponding rights,
    inability to participate in relevant activities, etc.); if you do not choose
    to cancel this service, {{ appName }} may restore the balance in your
    account. When/after enough, {{ appName }} will continue to provide you with
    automatic renewal services (specifically subject to the rules of each
    third-party payment channel). Once the deduction is successful,
    {{ appName }} will restore your SVIP service and this service. 2.5 You
    understand and agree that if you use a third-party payment channel to pay
    fees, you will also be bound by the third-party&#39;s terms of service and
    usage rules.

    <div class="bt">Article 3 Automatic renewal usage rules</div>

    3.1 After you choose to use this service, unless you choose to terminate the
    service, your automatic deduction authorization to {{ appName }} is
    irrevocable. {{ appName }} will deduct the fees based on the payment method
    you selected when you activated the automatic renewal service. , the fees
    paid by you will not be refunded in any way. 3.2 {{ appName }} does not
    charge any handling fee for you to activate this service, but
    {{ appName }} has the right to decide whether to charge or adjust the
    automatic renewal cycle and fees based on business needs or market changes,
    and make an announcement on the relevant page. If the price of
    {{ appName }}&#39;s &quot;SVIP&quot; monthly service is adjusted before the
    automatic renewal date, the current effective price will be deducted. 3.3 If
    an error occurs during the deduction process, {{ appName }} and you should
    work closely together to identify the cause, and each party shall bear the
    losses caused by its own fault; if the losses are caused by the unequal
    faults of both parties, both parties shall bear corresponding
    responsibilities according to the degree of fault; both parties shall bear
    the corresponding responsibilities. If there are joint responsibilities,
    both parties shall share the responsibilities equally. 3.4 If you purchase
    other SVIP service packages without canceling this service, such as
    purchasing a monthly package separately, or purchasing this service at the
    same time as you have purchased other SVIP service packages, the duration of
    this service and the duration of other service packages will be accumulated
    together. During the validity period of your SVIP service, you understand
    and agree that {{ appName }} will continue to deduct the fees for this
    service from your account. 3.5 The service provided by {{ appName }} to you
    is limited to your use on the {{ appName }} platform. Any use of
    &quot;SVIP&quot; rights and interests by malicious cracking or other illegal
    means to avoid renewal shall constitute a violation of this Agreement. The
    perpetrator shall be responsible for all legal consequences arising
    therefrom, and {{ appName }} will hold the perpetrator accountable in
    accordance with the law.

    <div class="bt">
      Article 4 Service Suspension, Interruption and Termination
    </div>

    4.1 Unless otherwise notified or announced by {{ appName }}, this service
    will be effective for a long time from the date you activate it until you
    choose to terminate the service. 4.2 It is up to you to choose whether to
    cancel this service. If you do not cancel, it will be deemed that you agree
    to {{ appName }}&#39;s attempt to renew the payment withheld in accordance
    with this agreement. Once the deduction is successful, {{ appName }} will
    increase the corresponding SVIP validity period for you (you can Check the
    validity period on the Personal Center-SVIP page). 4.3 If any of the
    following circumstances occurs, {{ appName }} has the right to immediately
    terminate the provision of services to you without any liability to you or
    any third party: (1) It is confirmed by the effective legal documents of the
    national administrative or judicial authorities that you have committed
    illegal or infringing acts, or {{ appName }}, based on its own judgment,
    believes that your behavior is suspected of violating the content of this
    Agreement or the usage rules announced by the {{ appName }} platform from
    time to time, or is suspected of violating Violating the provisions of laws
    and regulations; (2) Your behavior interferes with the normal operation of
    any part or function of {{ appName }}; (3) {{ appName }} believes that there
    are significant risks in providing this service to you. 4.4
    {{ appName }} may choose to suspend, interrupt and terminate this service
    based on its own business decisions and other reasons. If such a situation
    occurs, {{ appName }} will notify you in the form of an announcement. 4.5
    You can cancel this service through the following methods: Please manually
    open &quot;Settings&quot; on your Apple phone -&gt; Enter &quot;iTunes Store
    and App Store&quot; -&gt; Click &quot;Apple ID&quot;, select &quot;View
    Apple ID&quot;, enter the &quot;Account Settings&quot; page, click
    &quot;Subscribe&quot;, and select {{ appName }} &quot;SVIP&quot; can be
    automatically renewed by canceling the subscription. If the automatic
    renewal service is not turned off at least 24 hours before the end of the
    subscription period, this subscription will be automatically renewed and
    payment will be deducted. Once the deduction is successful, it will not be
    refunded and the service will be activated for you in the next billing
    cycle. 4.6 After you successfully cancel the automatic renewal service
    through the above method, it will not affect your &quot;SVIP&quot; rights
    and interests that have been in effect for the current period. After the
    &quot;SVIP&quot; rights and interests expire, they will no longer be
    automatically renewed. However, the instruction you have entrusted
    {{ appName }} with automatic renewal and deduction before choosing to cancel
    the automatic renewal service is still valid, and {{ appName }} will not
    refund the fees deducted based on this instruction.

    <br />
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  created() {},
};
</script>
<style scoped>
.protocol {
  font-size: 0.2267rem;
  margin-bottom: 0.4667rem;
  color: #666;
  margin-left: 0.4rem;
  margin-right: 0.4rem;
}
.bt {
  font-size: 0.4rem;
  margin: 0.2rem 0px;
  color: #7f1146;
}
</style>
